// sections
import { LoginForm } from "../../sections/auth/login";

// ----------------------------------------------------------------------

export default function LoginPage() {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-white">
      <div className="lg:w-1/2 flex items-center justify-center p-10 lg:p-20">
        <img
          src="/assets/illustrations/admin-login.png"
          alt="login"
          className="w-full max-w-md object-contain"
        />
      </div>

      <div className="lg:w-1/2 bg-orange-400 flex items-center justify-center p-8 lg:p-20">
        <div className="bg-white shadow-xl rounded-lg p-8 w-full max-w-md space-y-8">
          <h2 className="text-2xl font-semibold">Sign in</h2>
          <LoginForm />
        </div>
      </div>
    </div>
  );
}
